<template>
	<div class="wrapper" :style="position">

		<!-- Explore button on arrows for label slots -->
		<div v-if="show && label" class="hover-dot" :class="{ 'hover-dot-active': labelHover }" :style="explorePosition" @mouseenter="labelEnter" @mouseleave="labelLeave">
			<ExploreButton :cardValue="cardValue" @click="readMore" center />
		</div>

		<div :style="fixedSize">
			<!-- Slot -->
			<div id="animator" :class="{shake, flash, bounce}" :style="fixedSize">
				<div class="card" ref="card" :class="[type, labelArrow, {empty: empty || dragged, locked: locked && !image, label, hidden, incorrect}]" :style="outerCss">
					<!-- <img v-if="image" src="@/assets/components/component_bg_land_default.png" class="pointer-events-none"> -->
					<img v-if="image" :src='"@/assets/components/" + image + ".png"' class="pointer-events-none">
					<div v-else-if="!hidden" class="card-body" :style="innerCss">
						<span v-if="empty || dragged" class="card-text small">{{ $t('slot_empty') }}</span>
						<span v-else class="card-text">{{ slotText('title') }}</span>
					</div>

					<!-- Explore button on top of slot in the corner -->
					<ExploreButton v-if="show && !empty && !image && !label && !dragged" :cardValue="placedCard ? placedCardValue : cardValue" @click="readMore" />
				</div>
				<div v-if="incorrect" class="incorrect-bubble" style="z-index: 9;"></div>
			</div>

			<!-- Explore button on top of slot in the corner -->
			<ExploreButton v-if="hidden && cardValue" :cardValue="placedCard ? placedCardValue : cardValue" @click="readMore" />

			<!-- Arrow count badge -->
			<span
			v-if="arrowCount > 0"
			class="position-absolute top-0 start-100 translate-middle badge rounded-pill no-select"
			:class="{ 'bg-dark': highlight, 'bg-warning': !highlight, 'text-dark': !highlight, 'text-light': highlight }"
			style="border: 1px solid white; border-color: rgba(0, 0, 0, 0.5); z-index: 4; font-size: 0.85em;">
				<span>{{ arrowCount }}</span>
				<span :class="{ 'visually-hidden': !highlight }"> {{ $t("arrows_remaining") }}</span>
			</span>

			<!-- Name badge -->
			<span
			v-if="highlight && image"
			class="position-absolute start-50 translate-middle badge rounded-pill no-select"
			style="border: 1px solid white; border-color: rgba(0, 0, 0, 0.5); background-color: rgba(0,0,0,.7); z-index: 4; top: 100%; font-size: 0.65em;">
				<span>{{ slotText('title') }}</span>
			</span>
		</div>
	</div>
</template>



<script>
import ExploreButton from '@/components/ExploreButton.vue';

export default {
	props: [ "type", "slotId", "cardValue", "cardAlts", "x", "y", "anchor", "slotWidth", "slotHeight", "image", "bgImage", "arrow", "locked", "label", "hidden", "emptyColor", "lockColor", "allowInput", "allowArrows", "allowDrop", "arrowCount", "held", "hover", "selected", "incorrect", "zIndex", "labelHover" ],
	components: { ExploreButton },
	data() {
		return {
			show: true,
			empty: true,
			placedCard: null,
			dragged: false,
			shake: false,
			shakeTimeout: null,
			flash: false,
			flashTimeout: null,
			bounce: false,
			bounceTimeout: null,
			widthRatio: 1,
			heightRatio: 1,
			labelArrow: null,
			highlight: null,
			hoverTimeout: null,
		};
	},
	methods: {
		slotText(key) {
			if (this.placedCard) {
				return this.$t(`card_${this.placedCard.cardValue}_${key}`);
			}
			else {
				return this.$t(`card_${this.cardValue}_${key}`);
			}
		},
		place(card) {
			this.placedCard = card;
			this.empty = !this.placedCard;
		},
		hasCorrectCard() {
			// If slot has no card during verification it's probably locked
			if (!this.placedCard) {
				return true;
			}
			// Card matches the slot's value
			if (this.cardValue == this.placedCardValue) {
				return true;
			}
			// Card matches one of slot's alternative solutions
			if (this.cardAlts.includes(this.placedCardValue)) {
				return true;
			}
			return false;
		},
		clear() {
			this.placedCard = null;
			this.empty = true;
		},
		clearAnimations() {
			this.shake = false;
			this.flash = false;
			this.bounce = false;
			clearTimeout(this.shakeTimeout);
			clearTimeout(this.flashTimeout);
			clearTimeout(this.bounceTimeout);
		},
		playShake() {
			this.clearAnimations();
			setTimeout(() => {
				this.shake = true;
				this.shakeTimeout = setTimeout(() => {
					this.shake = false;
				}, 800);
			}, 50);
		},
		playFlash() {
			this.clearAnimations();
			setTimeout(() => {
				this.flash = true;
				this.flashTimeout = setTimeout(() => {
					this.flash = false;
				}, 800);
			}, 50);
		},
		playBounce() {
			this.clearAnimations();
			setTimeout(() => {
				this.bounce = true;
				this.bounceTimeout = setTimeout(() => {
					this.bounce = false;
				}, 800);
			}, 50);
		},
		getSize(graphics) {
			if (this.$refs.card) {
				let rect = this.$refs.card.getBoundingClientRect();
				let w = rect.width * (graphics.width / graphics.rect.width) + 4;
				let h = rect.height * (graphics.height / graphics.rect.height) + 4;
				return  { w, h };
			}
			return { w: 10, h: 10 };
		},
		labelEnter() {
			this.$emit('labelEnter');
		},
		labelLeave() {
			this.$emit('labelLeave');
		},
		readMore() {
			this.$emit('readMore', this.rect, this.type, this.placedCard ? this.placedCardValue : this.cardValue);
		},
	},
	computed: {
		position() {
			// return `left: calc(${this.x}*100%); top: calc(${this.y}*100%); transform: translate(-${this.anchor.x*100}%, -${this.anchor.y*100}%);`;
			// return `left: calc(${this.x}*100%); top: calc(${this.y}*100%); transform: translate(-50%, -50%);`;
			// const ax = (this.label ? 1.25 : 1.1) * (this.anchor.x - 0.5) + 0.5;
			// const ay = (this.label ? 2.25 : 1.5) * (this.anchor.y - 0.5) + 0.5;
			const ax = this.anchor.x;
			const ay = this.anchor.y;
			const dx = (this.label ? 6 : (this.arrow ? 2 : 0)) * (0.5 - this.anchor.x);
			const dy = (this.label ? 6 : (this.arrow ? 2 : 0)) * (0.5 - this.anchor.y);
			let style = {
				left: `${this.x}%`,
				top: `${this.y}%`,
				width: `${this.slotWidth}%`,
				height: `${this.slotHeight}%`,
				transform: `translate(calc(${-ax*100}% + ${dx}vmin), calc(${-ay*100}% + ${dy}vmin))`,
				zIndex: `${this.zIndex + 5*this.labelHover}`,
				// border: `1px dashed ${this.label ? '#00ff0055' : '#00000055'}`,
			};

			if (this.label) {
				if (!this.show || !this.labelHover) {
					style.pointerEvents = "none";
				}
			}

			return style;
		},
		fixedSize() {
			let style = {};
			if (this.slotWidth) { style.width = "100%"; }
			if (this.slotHeight) { style.height = "100%"; }
			return style;
		},
		explorePosition() {
			const dx = (this.label ? 6 : (this.arrow ? 2 : 0)) * (0.5 - this.anchor.x);
			const dy = (this.label ? 6 : (this.arrow ? 2 : 0)) * (0.5 - this.anchor.y);
			return {
				left: `calc( ${this.anchor.x*100}% - ${dx}vmin )`,
				top: `calc( ${this.anchor.y*100}% - ${dy}vmin )`,
				zIndex: 3 + this.zIndex + 5*this.labelHover,
				pointerEvents: "auto",
			};
		},
		outerCss() {
			let props = {};

			// props.zIndex = `${10 + this.zIndex + 5*this.labelHover}`;
			props.width = "100%";
			if (this.slotHeight)
				// props.height = `${this.slotHeight}vh`;
				props.height = "100%";

			if (this.label) {
				// props.backgroundColor = "#D1FFD8AA";
				if (!this.show || !this.labelHover) {
					props.opacity = 0.0;
					props.transform = `translate(${(this.anchor.x-0.5)*100}px, ${(this.anchor.y-0.5)*100}px) scale(0.5)`;
				}
			}
			if (this.locked && !this.allowArrows && !this.label) {
				props.backgroundColor = this.lockColor;
			}

			if (this.image) {
				props.border = "none";
				props.boxShadow = "none";
				props.backgroundColor = "transparent";
				props.backgroundImage = `url(${require(`@/assets/components/tile_${this.bgImage}.png`)})`;
			}

			if (this.empty || this.dragged) {
				props.backgroundColor = this.emptyColor;
			}

			if (!this.allowInput) {
				return props;
			}

			if (this.hover) {
				if (this.allowArrows) {
					props.transform = "scale(1.07)";
				}
				else if (this.arrowCount == null && (this.placedCard || this.allowDrop)) {
					// props.transform = "scale(1.07)";
					props.filter = "brightness(120%)";
					// props.backgroundColor = "#FFF5D6"; // Light yellow
				}
			}
			if (this.held && !this.dragged && this.arrowCount != 0)
				props.transform = "scale(0.95)";

			if (this.allowArrows) {
				if (this.selected && !this.image) {
					props.backgroundColor = "#FFC107"; // Yellow
					props.borderStyle = "solid";
				}
				if (this.hover || this.held) {
					if (this.image) {
						props.backgroundImage = `url(${require(`@/assets/components/tile_selected.png`)})`;
					}
					else {
						props.backgroundColor = "var(--bs-warning)"; // Yellow
						props.borderStyle = "solid";
						// props.backgroundColor = "#FFE085";
					}
				}
			}
			if (this.arrowCount != null) {
				if (this.arrowCount == 0) {
					props.backgroundColor = "var(--bs-gray-500)";
					if (this.image)
						props.filter = "grayscale(100%) brightness(60%)";
				}
				else if (!this.hover && !this.held && !this.image) {
					props.backgroundColor = "#FFECB0"; // Light yellow
					props.borderStyle = "solid";
				}
			}

			if (this.image) {
				props.backgroundColor = "transparent";
			}

			return props;
		},
		innerCss() {
			let props = {};

			props.backgroundColor = "transparent";
			// if (this.hover)
			// 	props.backgroundColor = "#FFFFFF";
			// if (this.arrowCount != null && this.arrowCount == 0)
			// 	props.backgroundColor = "#F8F9FA77";

			// props.backgroundColor = "#FFFFFF66";
			// props.color = "var(--bs-dark)";

			if (this.allowArrows && !this.image) {
				props.backgroundColor = "#FFFFFFBB";
				props.borderStyle = "solid";
				props.borderWidth = "1px";
				props.borderColor = "rgba(0,0,0,.2)";

				if (this.arrowCount == 0)
					props.color = "var(--bs-gray)";
			}

			if (!this.slotHeight) {
				if (this.empty) {
					props.padding = "1.4vh 0.6vh";
				}
				else if (this.label) {
					props.padding = "1.0vh 0.9vh";
				}
				else {
					props.padding = "1.7vh 0.9vh";
				}
			}

			return props;
		},

		placedCardId() {
			return this.placedCard ? this.placedCard.cardId : null;
		},
		placedCardValue() {
			return this.placedCard ? this.placedCard.cardValue : null;
		},

		rect() {
			return this.$refs.card.getBoundingClientRect();
		},
		width() {
			return this.rect.width * this.widthRatio;
			// return this.$refs.card.offsetWidth;
		},
		height() {
			return this.rect.height * this.heightRatio;
			// return this.$refs.card.offsetHeight;
		},
	},
	watch: {
		hover(value) {
			this.highlight = false;
			clearTimeout(this.hoverTimeout);
			if (value) {
				this.hoverTimeout = setTimeout(() => {
					this.highlight = true;
				}, 1000);
			}
		}
		// placedCard() {
			// playFlash()
		// },
	},
	mounted() {
		if (this.locked || this.label) {
			this.empty = false;
		}
		if (!this.locked && this.label) {
			this.show = false;
			// this.show = true;
		}

		if (this.label) {
			if (this.anchor.x == 0.0) {
				this.labelArrow = "labelLeft";
			}
			else if (this.anchor.x == 1.0) {
				this.labelArrow = "labelRight";
			}
			else if (this.anchor.y == 0.0) {
				this.labelArrow = "labelTop";
			}
			else if (this.anchor.y == 1.0) {
				this.labelArrow = "labelBottom";
			}
		}
	}
};
</script>



<style scoped>
	.wrapper {
		position: absolute;
	}


	.card {
		border: none;
		border-radius: 0.4em;
		color: white;
		text-align: center;
		padding: 0.3vh;
		user-select: none;
		/*box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3);*/
		/*box-shadow: 1px 2px 4px rgb(0 0 0 / 55%);*/
		box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.2);

		background-repeat: no-repeat;
		background-position: center;
		background-size: contain;

		transition: all .06s ease-in;
		/*filter: grayscale(100%) brightness(150%) sepia(50%) hue-rotate(50deg) saturate(300%);*/
		/*filter: grayscale(100%) brightness(1000%);*/
	}

	.card-body {
		border: 1px solid white;
		/*border: none;*/
		border-radius: calc(0.4em - 0.2em);
		/*box-shadow: 0 1px 4px rgb(0 0 0 / 55%);*/

		display: flex;
		flex-direction: column;
		justify-content: center;

		hyphens: auto;
		transition: all .06s ease-in;
		padding: 0.9vh;
		padding: 0.1vh 0.9vh;
/*		background-color: red;*/

/*		font-size: 1.6vh;*/
		overflow: hidden;
/*		font-size: 1.9vh;*/
/*		margin-top: 0;*/
/*		margin-bottom: 0.5rem;*/
		font-weight: 500;
		line-height: 1.2;
	}

	.card-text {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3; /* number of lines to show */
				line-clamp: 3; 
		-webkit-box-orient: vertical;
	}

	.empty {
		/*background-color: #d9f1ff77;*/
		border: 1px solid #000000;
		/*border-left-width: 0px;*/
		/*border-top-width: 2px;*/
		/*border-right-width: 0px;*/
		/*border-bottom-width: 0px;*/
		/*box-shadow: 0px 1px 3px rgb(0 0 0 / 35%);*/
		box-shadow: inset 1px 2px 8px rgb(0 0 0 / 75%);
		backdrop-filter: blur(2px);
		color: #333;
		padding: 0.8vh;
	}
	.empty .card-body {
		/*border: none;*/
		border: 1px dashed #00000077;
		/*box-shadow: inset 1px 2px 4px rgb(0 0 0 / 35%);*/
		color: #000000AA;
		/*text-shadow: 0px 0px 10px white;*/
		font-style: italic;
		/*border: 3px dotted #00000077;*/
/*		padding: 0.6vh;*/
/*		font-size: 1.8vh;*/
	}

	.locked {
		/*backdrop-filter: blur(4px);*/
		color: #333;
		/*border: 1px dashed #00000066;*/
		border: 1px solid #00000066;
	}
	.locked .card-body {
		border: none;
		/*border: 1px dashed rgba(0, 0, 0, 0.2);*/
		/*border-color: rgba(0, 0, 0, 0.5);*/
	}

	.label {
/*		border: 1px solid var(--label-text);*/
		background-color: var(--label);
		color: var(--label-text);
		backdrop-filter: blur(10px);
		transition: all 250ms ease;
		box-shadow: none;
	}
	.label .card-body {
		border: none;
		padding: 0.2em;
	}

	.hidden {
		opacity: 0.0;
	}


	.incorrect {
		background-color: #b83d30;
		background-color: var(--bs-danger);
	}
	.incorrect-bubble {
		position: absolute;
		left: -1em;
		top: 50%;
		transform: translate(-50%, -50%);
		border: 1px solid white;
		width: 1.5em;
		height: 1.5em;
		background-color: var(--bs-danger);
		border-radius: 100%;
		/*color: black;*/
		background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV8/pCIVQQuKOESoThZERRy1CkWoEGqFVh1MLv2CJg1Jiouj4Fpw8GOx6uDirKuDqyAIfoA4OjkpukiJ/0sKLWI8OO7Hu3uPu3eAv15mqhkcB1TNMlKJuJDJrgqhVwTRj14MIyYxU58TxSQ8x9c9fHy9i/Es73N/jm4lZzLAJxDPMt2wiDeIpzctnfM+cYQVJYX4nHjMoAsSP3JddvmNc8FhP8+MGOnUPHGEWCi0sdzGrGioxFPEUUXVKN+fcVnhvMVZLVdZ8578heGctrLMdZpDSGARSxAhQEYVJZRhIUarRoqJFO3HPfyDjl8kl0yuEhg5FlCBCsnxg//B727N/OSEmxSOAx0vtv0xAoR2gUbNtr+PbbtxAgSegSut5a/UgZlP0mstLXoE9GwDF9ctTd4DLneAgSddMiRHCtD05/PA+xl9UxbouwW61tzemvs4fQDS1FXyBjg4BEYLlL3u8e7O9t7+PdPs7weicHK6lyUd8gAAAAZiS0dEABoAvACc5u7sRwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+YEFxI4MBpjYJAAAAIkSURBVHja7Zo9a1RBFIbfSUwsUmhsjLaxEGvTBGz9ABtB/AU2FpKAhWBrm9I/Ym0jNhYWIhgSNBpERVZ388Vm16zZPBZ70+iSOxN0dvfc85TLGe49z8ydObMzkuM4juNUljCIhwLnJV2RdElSW9KKpBchhE3TtoFp4AnQ5G9qwCNg0mryM8BrynlqTgIQisRieWxNwDywnyBgE5jJ8W5jmRzckTSeEH9a0nVLAk5lajO0AoYWF5DpOY1jtNmwJOBzpjZDK+BbYvyBpJolAd+PIeCHtU+gmzhnNC0J2JZEQnxLUseSgJ3Eb3othHBgScC+pL3EEWCnDih6cyWhybLFSvDnf4odGQHLVR8BrcrOAQXvEoqg9xYFbEfG/bI6Aj4VvVtGU1LdooCdyNm9nlg2j4yALfUOQcqo5aoCcwvoRm6Lv2R8p3wCil6NOfpqmBRwuMmJiPlgWcD6P4oZTYALwO4RJ0LrwJQsA9wH2n2S3wCu5X6fQd0PuCzpgaSzxU+rkpZCCB/lOI5TgUnwhKQ5SRfV+8P0jaS3OfcAg1wGbwFrfZbBV8C89eQXgO4RhVAbuGk1+TmgE3E/qJHrflDuvcBDSRMRcWck3bPW+5NAPeGW2EtrI+Ckeje/YjlnTUBHacfdDVMCQgh7klKG9XOLq8DVkiXwkBYwa3UpXCpJvgvctVwIjQGLwFaf5L8Ct6uyF5iWdOOPvcCzEEJLjuM4juPk4jeWtHbeg81BbwAAAABJRU5ErkJggg==');
		background-position: center;
		background-size: contain;
		/*border-color: var(--bs-danger);*/
		/*filter: grayscale(100%) brightness(80%) sepia(100%) hue-rotate(-50deg) saturate(600%);*/
		/*filter: grayscale(100%) brightness(40%) sepia(100%) hue-rotate(-50deg) saturate(600%);*/
		/*box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3), 0px 0px 8px 2px rgba(255, 0, 0, 1.0);*/
	}
	.incorrect .card-body {
		/*border: 2px solid var(--bs-danger);*/
		/*color: var(--bs-danger);*/
		/*opacity: 0.5;*/
	}


	.hover-dot {
		z-index: 3;
		/*position: absolute; width: 2em; height: 2em; background: rgba(0,0,0,0.2); border-radius: 100%; transform: translate(-50%, -50%);*/
		transition: border-color 150ms ease-in-out,opacity 150ms ease-in-out,visibility 150ms ease-in-out;
		transform: translateX(-1rem) translateY(-1rem) scale(0.999);
		padding: 0;
		width: 2rem;
		height: 2rem;
		border: 2px solid transparent;
		position: absolute;
/*		background: rgba(0,0,0,.2);*/
		/*opacity: 0;*/
		/*visibility: hidden;*/
		border-radius: 64px;
		line-height: .5;
		display: flex;
		align-items: center;
		justify-content: center;
	}


	.shake {
		animation: Shake .6s ease-out;
	}
	@keyframes Shake {
		0%	{ transform: translate(calc(2.0*10.0px)); filter: grayscale(100%) brightness(40%) sepia(100%) hue-rotate(-50deg) saturate(600%); } /* Red */
		10%	{ transform: translate(calc(2.0*-8.1px)); }
		20%	{ transform: translate(calc(2.0*6.4px)); }
		30%	{ transform: translate(calc(2.0*-4.9px)); }
		40%	{ transform: translate(calc(2.0*3.6px)); }
		50%	{ transform: translate(calc(2.0*-2.5px)); }
		60%	{ transform: translate(calc(2.0*1.6px)); }
		70%	{ transform: translate(calc(2.0*-0.9px)); }
		80%	{ transform: translate(calc(2.0*0.4px)); }
		90%	{ transform: translate(calc(2.0*-0.1px)); }
		100%{ transform: translate(calc(2.0*0.0px)); }
	}

	.flash {
		animation: Flash .6s ease;
	}
	@keyframes Flash {
		0%	{ transform: scale(1.10); filter: brightness(500%); }
		25%	{ transform: scale(0.95); }
		50%	{ transform: scale(1.02); filter: brightness(110%); }
		75%	{ transform: scale(0.99); }
		100%{ transform: scale(1.00); }
	}

	.bounce {
		animation: Bounce .6s ease-out;
	}
	@keyframes Bounce {
		0%	{ transform: scale(1.10); }
		25%	{ transform: scale(0.95); }
		50%	{ transform: scale(1.02); }
		75%	{ transform: scale(0.99); }
		100%{ transform: scale(1.00); }
	}


	/* Speech bubble arrows */
	.labelLeft:before {
		content: "";
		width: 0px;
		height: 0px;
		position: absolute;
		border-left: 10px solid transparent;
		border-right: 10px solid var(--label);
		border-top: 10px solid transparent;
		border-bottom: 10px solid transparent;
		left: -20px;
		top: calc(50% - 10px);
	}

	.labelRight:before {
		content: "";
		width: 0px;
		height: 0px;
		position: absolute;
		border-left: 10px solid var(--label);
		border-right: 10px solid transparent;
		border-top: 10px solid transparent;
		border-bottom: 10px solid transparent;
		right: -20px;
		top: calc(50% - 10px);
	}
	.labelTop:before {
		content: "";
		width: 0px;
		height: 0px;
		position: absolute;
		border-left: 10px solid transparent;
		border-right: 10px solid transparent;
		border-top: 10px solid transparent;
		border-bottom: 10px solid var(--label);
		right: calc(50% - 10px);
		top: -20px;
	}
	.labelBottom:before {
		content: "";
		width: 0px;
		height: 0px;
		position: absolute;
		border-left: 10px solid transparent;
		border-right: 10px solid transparent;
		border-top: 10px solid var(--label);
		border-bottom: 10px solid transparent;
		right: calc(50% - 10px);
		bottom: -20px;
	}
</style>
